import {
  G_LIMIT_MB_X_GB_RAM_MD_AND_DOWN,
  G_LIMIT_MB_025_GB_RAM,
  G_LIMIT_MB_05_GB_RAM,
  G_LIMIT_MB_1_GB_RAM,
  G_LIMIT_MB_2_GB_RAM,
  G_LIMIT_MB_4_GB_RAM,
  G_LIMIT_MB_8_GB_RAM,
} from "@/constants";

function lightenDarkenColor(col, amt) {
  var usePound = false;
  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
}

function formatBytes(bytes, decimals) {
  if (bytes == 0) return "0 B";
  var k = 1024,
    dm = decimals <= 0 ? 0 : decimals || 2,
    sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

function isFacebookApp() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return (
    ua.indexOf("FBAN") > -1 ||
    ua.indexOf("FBAV") > -1 ||
    ua.indexOf("Instagram") > -1
  );
}

function checkBrowser() {
  // Get the user-agent string
  let userAgentString = navigator.userAgent;

  // Detect Chrome
  let chromeAgent = userAgentString.indexOf("Chrome") > -1;

  // Detect Internet Explorer
  let IExplorerAgent =
    userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;

  // Detect Firefox
  let firefoxAgent = userAgentString.indexOf("Firefox") > -1;

  // Detect Safari
  let safariAgent = userAgentString.indexOf("Safari") > -1;

  // Discard Safari since it also matches Chrome
  if (chromeAgent && safariAgent) safariAgent = false;

  // Detect Opera
  let operaAgent = userAgentString.indexOf("OP") > -1;

  // Discard Chrome since it also matches Opera
  if (chromeAgent && operaAgent) chromeAgent = false;

  if (chromeAgent) {
    return "Chrome";
  } else if (IExplorerAgent) {
    return "Explorer";
  } else if (firefoxAgent) {
    return "Firefox";
  } else if (safariAgent) {
    return "Safari";
  } else if (operaAgent) {
    return "Opera";
  } else return "?Browser";
}

function checkOS() {
  var userAgent = navigator.userAgent,
    platform = navigator.platform,
    macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
}

function checkMemory() {
  if (navigator.deviceMemory > 0) {
    return navigator.deviceMemory;
  } else return "?";
}

function maxMB() {
  if (checkMemory() == "?") {
    return G_LIMIT_MB_X_GB_RAM_MD_AND_DOWN;
  } else if (checkMemory() == 0.25) {
    return G_LIMIT_MB_025_GB_RAM;
  } else if (checkMemory() == 0.5) {
    return G_LIMIT_MB_05_GB_RAM;
  } else if (checkMemory() == 1) {
    return G_LIMIT_MB_1_GB_RAM;
  } else if (checkMemory() == 2) {
    return G_LIMIT_MB_2_GB_RAM;
  } else if (checkMemory() == 4) {
    return G_LIMIT_MB_4_GB_RAM;
  } else if (checkMemory() == 8) {
    return G_LIMIT_MB_8_GB_RAM;
  }
}

function parseRGBA(x) {
  return (
    "rgba(" +
    parseInt(x.substring(1, 3), 16) +
    ", " +
    parseInt(x.substring(3, 5), 16) +
    ", " +
    parseInt(x.substring(5, 7), 16) +
    ", " +
    Math.trunc((parseInt(x.substring(7, 9), 16) * 100) / 255) / 100 +
    ")"
  );
}

function makeId(length, mode) {
  let result = '';
  let characters = '';
  let charactersLength = 0;

  if (mode == 0) {
    characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    charactersLength = characters.length;
  } else {
    characters = '0123456789'
    charactersLength = characters.length;
  }

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
}

function convertQR(str) {
  let returnStr = str;

  returnStr = returnStr.replace(/č/g, "c");
  returnStr = returnStr.replace(/Č/g, "C");
  returnStr = returnStr.replace(/š/g, "s");
  returnStr = returnStr.replace(/Š/g, "S");
  returnStr = returnStr.replace(/ž/g, "z");
  returnStr = returnStr.replace(/Ž/g, "Z");
  returnStr = returnStr.replace(/đ/g, "d");
  returnStr = returnStr.replace(/Đ/g, "D");
  returnStr = returnStr.replace(/ć/g, "c");
  returnStr = returnStr.replace(/Ć/g, "C");
  returnStr = returnStr.replace(/[^a-z0-9 .]/gi, "");

  return returnStr;
}

export {
  makeId,
  lightenDarkenColor,
  formatBytes,
  checkBrowser,
  checkOS,
  checkMemory,
  maxMB,
  isFacebookApp,
  parseRGBA,
  convertQR,
};
